import { PASSWORD_MIN_LENGTH } from "../../../../common/src";
import { Field } from "../shared/Field";
import { useFormStyles } from "../shared/styles";

interface NewPasswordFieldsProps {
  password: string;
  confirm: string;
  onPasswordChange: (value: string) => void;
  onConfirmChange: (value: string) => void;
  passwordError?: string;
  confirmError?: string;
}

/** "Choose a password" and "Confirm password" inputs, wired for password managers. */
export const NewPasswordFields = ({
  password,
  confirm,
  onPasswordChange,
  onConfirmChange,
  passwordError,
  confirmError,
}: NewPasswordFieldsProps) => {
  const form = useFormStyles();
  return (
    <>
      <Field
        label="Choose a password"
        htmlFor="new-password"
        hint={`At least ${PASSWORD_MIN_LENGTH} characters. A short phrase works well.`}
        error={passwordError}
      >
        <input
          id="new-password"
          type="password"
          className={form.control}
          autoComplete="new-password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
        />
      </Field>
      <Field
        label="Confirm password"
        htmlFor="confirm-password"
        error={confirmError}
      >
        <input
          id="confirm-password"
          type="password"
          className={form.control}
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => onConfirmChange(e.target.value)}
        />
      </Field>
    </>
  );
};
